import { hasCapability, type User } from "../base";
import { NON_EXISTENT_ID } from "../utils/types";

export const propertyAddress = {
  update: (user: User) => hasCapability(user, "propertyAddress.update"),
  read: (_user: User) => true,
};

export const propertyAddressUpdateWhere = (user: User) => {
  if (hasCapability(user, "propertyAddress.update.all")) {
    return {};
  }
  if (hasCapability(user, "propertyAddress.update.owned")) {
    return { workSites: { some: { homeownerId: user.person.id } } };
  }
  return { id: NON_EXISTENT_ID };
};
